<banner-app [retroSelected]="false" [Loader]="true" [infoDueno]="true" [showPromo]="true"></banner-app>

<div class="mainContainer justify-content-center align-items-center">
  <div class="textContainer d-flex flex-column align-items-center mb-4">
    <span class="title">La información del RUNT <br />está desactualizada</span>
    <span class="subtitle">Déjanos tus datos y nos pondremos en contacto contigo ;)</span>
  </div>

  <div class="formContainer d-flex flex-column align-items-center">
    <form [formGroup]="formulario" class="w-100 d-flex flex-column align-items-center">
      <div class="form-item-container inputContainer">
        <label for="nombreCliente">*Nombre</label>
        <input
          type="text"
          #nombreCliente
          required
          class="form-control inputColor textInput"
          formControlName="nombreCliente"
          id="nombreCliente"
          placeholder="Ingresa tu nombre"
          [ngClass]="{ valNombre: valNombre }"
          (focusout)="validacionNombre()"
          [ngModel]="this.datosGenerales?.Lead?.name"
          onkeydown="return /[a-z, ñÑ, íÍ, óÓ, áÁ, éÉ, úÚ]/i.test(event.key)"
        />
        <small *ngIf="nombreNoValido" class="text-danger"> Asegúrate de llenar este campo </small>
      </div>

      <div class="form-item-container inputContainer">
        <label for="numCelular">*Número de celular</label>

        <input
          type="text"
          class="form-control inputColor textInput"
          #numCelular
          formControlName="numCelular"
          id="numCelular"
          placeholder="Ej: 3004263078"
          required
          autocomplete="off"
          onkeypress="return (event.charCode >= 48 && event.charCode <= 57)"
          min="1"
          [maxlength]="10"
          [ngClass]="{ valCelular: valCelular }"
          (focusout)="validacionCelular()"
        />
        <small *ngIf="cedularNoValido" class="text-danger"> Asegúrate de ingresar un número válido de 10 dígitos </small>
      </div>

      <div class="form-item-container inputContainer">
        <label for="floatingCorreo">*Correo electrónico</label>

        <input
          type="text"
          class="form-control inputColor textInput"
          #correo
          formControlName="correo"
          id="correo"
          placeholder="Ej: usuario@correo.com"
          required
          [ngClass]="{ valEmail: valEmail }"
          (focusout)="validacionEmail()"
          (keydown)="blockUnicode($event)"
        />
        <small *ngIf="correoNoValido" class="text-danger">Asegúrate de incluir el símbolo &#64;</small>
      </div>

      <p class="warningMessage mt-1">*Los campos son obligatorios</p>

      <div class="form-check text-start my-2 autorizationContainer">
        <input
          class="form-check-input"
          type="checkbox"
          formControlName="flexCheckAutoriza"
          value="remember-me"
          id="flexCheckAutoriza"
          name="flexCheckAutoriza"
          required
        />
        <a id="autoriza" class="autorizationText" (click)="openModal()">
          Autorizo a <strong>Suramericana S.A.</strong> el tratamiento de mis datos para las finalidades contenidas en la
          <strong>política de privacidad</strong>, donde también se encuentran los canales de contacto y la forma de ejercer mis derechos.
        </a>
      </div>
    </form>
    <button [disabled]="formularioNoValido" class="btn btn-primary localButton" (click)="siguientePagina()">Enviar</button>
  </div>
</div>
<app-footer-app />
